import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { Subject, tap } from 'rxjs';

import { environment } from '../../../../../environments/environment';
import { StringResponse } from '../../../../models/string.model';
import { ApiResponse } from '../../../../models/api-response.model';
import { UpdateResponse } from '../../../../models/ws-user/update-password-response.model';
import { AuthRefresh, LoginRequest } from '../../../../models/ws-user';

const URL = `${environment.url}/auth`;

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private loginSubject = new Subject<ApiResponse<UpdateResponse>>();
  constructor(private http: HttpClient) { }

  login(user: LoginRequest) {
    return this.http.post<ApiResponse<UpdateResponse>>(URL, user, { withCredentials: true }).pipe(
      tap(response => {
        this.loginSubject.next(response);
      })
    );
  }

  getLoginObservable() {
    return this.loginSubject.asObservable();
  }

  logout(obj?: { token: string }) {
    return this.http.post(`${URL}/logout`, obj, { withCredentials: true });
  }

  refreshToken(refresh: string) {
    return this.http.post<ApiResponse<AuthRefresh>>(`${URL}/refresh-token`, { token: refresh }, { withCredentials: true });
  }

  revokeToken() {
    return this.http.post<ApiResponse<string>>(`${URL}/revoke-token`, {});
  }

  forgotPassword(email: string) {
    localStorage.clear();
    return this.http.post<ApiResponse<string>>(`${URL}/forgot-password`, email);
  }

  verifyEmail(obj: { token: string }) {
    return this.http.post(`${URL}/verify-email`, obj);
  }

  checkPasswordRecovery(token: string): Observable<StringResponse> {
    return this.http.post<StringResponse>(`${URL}/check-password-recovery`, { token });
  }

  passwordRecovery(token: string, newPassword: string): Observable<StringResponse> {
    return this.http.post<StringResponse>(`${URL}/password-recovery`, { token, newPassword });
  }
}
